// Verified imagery from design guidelines
const DEFAULT_IMG = {
  heroTower:
    "https://images.unsplash.com/photo-1643155193188-38eb08e2b54f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHx0ZWxlY29tJTIwaW5mcmFzdHJ1Y3R1cmV8ZW58MHx8fHwxNzgxMDM5OTc1fDA&ixlib=rb-4.1.0&q=85",
  towerSunset:
    "https://images.unsplash.com/photo-1696240485026-90cf2acfae16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHx0ZWxlY29tJTIwdG93ZXIlMjBzdW5zZXR8ZW58MHx8fHwxNzgxMDM5OTY2fDA&ixlib=rb-4.1.0&q=85",
  engineer:
    "https://images.unsplash.com/photo-1768677903496-becc4be07258?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxlbmdpbmVlciUyMGNvbnN0cnVjdGlvbiUyMHNpdGV8ZW58MHx8fHwxNzgxMDM5OTY2fDA&ixlib=rb-4.1.0&q=85",
  siteWork:
    "https://images.pexels.com/photos/1078879/pexels-photo-1078879.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cityNight:
    "https://images.unsplash.com/photo-1663900108404-a05e8bf82cda?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxzYXVkaSUyMGFyYWJpYSUyMG5pZ2h0fGVufDB8fHx8MTc4MTAzOTk3NXww&ixlib=rb-4.1.0&q=85",
};

// Existing pages keep their original imagery, while the CMS can override any image key at runtime.
export const IMG = new Proxy(DEFAULT_IMG, {
  get(target, prop) {
    if (typeof window !== "undefined" && window.__TL_ASSETS__?.[prop]) return window.__TL_ASSETS__[prop];
    return target[prop];
  },
});

const rot = [IMG.heroTower, IMG.towerSunset, IMG.engineer, IMG.siteWork, IMG.cityNight];

// ---------- Services (Home) ----------
export const services = [
  { icon: "RadioTower", en: { title: "Telecom Towers", desc: "Design, supply & installation of all tower types." }, ar: { title: "أبراج الاتصالات", desc: "تصميم وتوريد وتركيب جميع أنواع الأبراج." } },
  { icon: "Antenna", en: { title: "Monopole Towers", desc: "Slim, fast-deploy structures for urban sites." }, ar: { title: "الأبراج أحادية العمود", desc: "هياكل نحيلة سريعة النشر للمواقع الحضرية." } },
  { icon: "TowerControl", en: { title: "Self-Support Towers", desc: "High-capacity lattice towers for heavy loading." }, ar: { title: "الأبراج ذاتية الدعم", desc: "أبراج شبكية عالية السعة للأحمال الثقيلة." } },
  { icon: "Triangle", en: { title: "3-Leg Towers", desc: "Triangular lattice for efficient footprints." }, ar: { title: "أبراج ثلاثية القوائم", desc: "هيكل شبكي ثلاثي بمساحة فعّالة." } },
  { icon: "Square", en: { title: "4-Leg Towers", desc: "Maximum stability for tall, loaded structures." }, ar: { title: "أبراج رباعية القوائم", desc: "أقصى ثبات للهياكل العالية والمحمّلة." } },
  { icon: "Cable", en: { title: "Guyed Towers", desc: "Tall, cost-effective guyed mast solutions." }, ar: { title: "الأبراج المشدودة", desc: "حلول صواري مشدودة عالية واقتصادية." } },
  { icon: "Building2", en: { title: "Rooftop Towers", desc: "Rooftop poles & frames for dense networks." }, ar: { title: "أبراج الأسطح", desc: "أعمدة وهياكل أسطح للشبكات الكثيفة." } },
  { icon: "HardHat", en: { title: "Civil Works", desc: "Complete site civil & structural works." }, ar: { title: "الأعمال المدنية", desc: "أعمال مدنية وإنشائية متكاملة للموقع." } },
  { icon: "Layers", en: { title: "Foundation Design", desc: "Engineered foundations for any soil profile." }, ar: { title: "تصميم الأساسات", desc: "أساسات مهندسة لأي نوع تربة." } },
  { icon: "Wrench", en: { title: "Tower Installation", desc: "Certified erection & rigging crews." }, ar: { title: "تركيب الأبراج", desc: "فرق تركيب ورفع معتمدة." } },
  { icon: "MoveRight", en: { title: "Tower Relocation", desc: "Safe dismantling, transport & re-erection." }, ar: { title: "نقل الأبراج", desc: "فك ونقل وإعادة تركيب آمنة." } },
  { icon: "Network", en: { title: "Fiber Infrastructure", desc: "FTTx, backbone & site fiber deployment." }, ar: { title: "البنية التحتية للألياف", desc: "نشر الألياف للشبكة والمواقع." } },
  { icon: "Satellite", en: { title: "Antenna Solutions", desc: "Sector, microwave & omni antenna systems." }, ar: { title: "حلول الهوائيات", desc: "أنظمة هوائيات قطاعية وميكروويف." } },
  { icon: "Boxes", en: { title: "Telecom Materials", desc: "Full catalog of network materials & accessories." }, ar: { title: "مواد الاتصالات", desc: "كتالوج كامل لمواد وملحقات الشبكة." } },
  { icon: "BatteryCharging", en: { title: "Power Systems", desc: "Rectifiers, batteries & solar power." }, ar: { title: "أنظمة الطاقة", desc: "موحدات وبطاريات وطاقة شمسية." } },
  { icon: "Plane", en: { title: "Aviation Obstruction Lights", desc: "ICAO-compliant tower lighting." }, ar: { title: "أضواء عوائق الطيران", desc: "إضاءة أبراج متوافقة مع ICAO." } },
  { icon: "Zap", en: { title: "Earthing Systems", desc: "Grounding & lightning protection." }, ar: { title: "أنظمة التأريض", desc: "تأريض وحماية من الصواعق." } },
  { icon: "MapPinned", en: { title: "Site Survey", desc: "Detailed site survey & feasibility." }, ar: { title: "مسح الموقع", desc: "مسح موقع تفصيلي ودراسة جدوى." } },
];

// ---------- Tower Solutions ----------
export const towerTypes = [
  {
    id: "monopole", image: IMG.heroTower,
    en: { title: "Monopole Towers", desc: "Single-pole steel structures ideal for urban and space-constrained sites where aesthetics and fast deployment matter.", heights: "6m – 40m", apps: "Urban macro sites, street furniture, in-fill coverage", industries: "Telecom Operators, Smart Cities, Municipalities" },
    ar: { title: "الأبراج أحادية العمود", desc: "هياكل فولاذية بعمود واحد مثالية للمواقع الحضرية والمحدودة المساحة حيث يهم المظهر وسرعة النشر.", heights: "٦م – ٤٠م", apps: "مواقع حضرية، أثاث الشوارع، تغطية تكميلية", industries: "مشغلو الاتصالات، المدن الذكية، البلديات" },
  },
  {
    id: "self-support", image: IMG.towerSunset,
    en: { title: "Self-Support Towers", desc: "Free-standing lattice towers offering high load capacity without guy wires, suited for heavy antenna configurations.", heights: "15m – 80m", apps: "Macro coverage, multi-operator co-location, microwave", industries: "Operators, Infrastructure Contractors, Government" },
    ar: { title: "الأبراج ذاتية الدعم", desc: "أبراج شبكية قائمة بذاتها توفر سعة تحميل عالية دون أسلاك شد، مناسبة لتكوينات الهوائيات الثقيلة.", heights: "١٥م – ٨٠م", apps: "تغطية واسعة، مشاركة متعددة المشغلين، ميكروويف", industries: "المشغلون، مقاولو البنية، الحكومة" },
  },
  {
    id: "3-leg", image: IMG.engineer,
    en: { title: "3-Leg Towers", desc: "Triangular lattice towers delivering an efficient strength-to-footprint ratio for cost-sensitive deployments.", heights: "12m – 60m", apps: "Rural coverage, backhaul, private networks", industries: "Operators, Utilities, Oil & Gas" },
    ar: { title: "أبراج ثلاثية القوائم", desc: "أبراج شبكية ثلاثية توفر نسبة قوة إلى مساحة فعّالة للمشاريع الحساسة للتكلفة.", heights: "١٢م – ٦٠م", apps: "تغطية ريفية، نقل، شبكات خاصة", industries: "المشغلون، المرافق، النفط والغاز" },
  },
  {
    id: "4-leg", image: IMG.siteWork,
    en: { title: "4-Leg Towers", desc: "Square-base lattice towers providing maximum stability and load capacity for the tallest, most demanding structures.", heights: "20m – 120m", apps: "High-load macro, broadcast, multi-tenant", industries: "Operators, Broadcasters, Government" },
    ar: { title: "أبراج رباعية القوائم", desc: "أبراج شبكية رباعية القاعدة توفر أقصى ثبات وسعة تحميل لأطول الهياكل وأكثرها تطلباً.", heights: "٢٠م – ١٢٠م", apps: "أحمال عالية، بث، متعدد المستأجرين", industries: "المشغلون، هيئات البث، الحكومة" },
  },
  {
    id: "guyed", image: IMG.cityNight,
    en: { title: "Guyed Towers", desc: "Mast structures supported by tensioned guy wires, enabling great heights at the most economical cost.", heights: "30m – 150m+", apps: "Broadcast, long-haul microwave, remote sites", industries: "Broadcasters, Utilities, Government" },
    ar: { title: "الأبراج المشدودة", desc: "هياكل صواري مدعومة بأسلاك شد، تتيح ارتفاعات كبيرة بأقل تكلفة.", heights: "٣٠م – ١٥٠م+", apps: "بث، ميكروويف طويل المدى، مواقع نائية", industries: "هيئات البث، المرافق، الحكومة" },
  },
  {
    id: "rooftop", image: IMG.heroTower,
    en: { title: "Rooftop Towers", desc: "Lightweight poles and frames engineered for building rooftops to densify urban network capacity.", heights: "3m – 15m", apps: "Urban densification, small cells, in-building", industries: "Operators, Smart Cities, Data Centers" },
    ar: { title: "أبراج الأسطح", desc: "أعمدة وهياكل خفيفة مصممة لأسطح المباني لتكثيف سعة الشبكة الحضرية.", heights: "٣م – ١٥م", apps: "تكثيف حضري، خلايا صغيرة، داخل المباني", industries: "المشغلون، المدن الذكية، مراكز البيانات" },
  },
  {
    id: "custom", image: IMG.towerSunset,
    en: { title: "Custom Telecom Structures", desc: "Bespoke structures including camouflage towers, hybrid masts and special-purpose frames to client specification.", heights: "Project specific", apps: "Special projects, NEOM, heritage & camouflage sites", industries: "Government, Smart Cities, Mega Projects" },
    ar: { title: "هياكل اتصالات مخصصة", desc: "هياكل مخصصة تشمل الأبراج المموهة والصواري الهجينة والأطر خاصة الغرض حسب مواصفات العميل.", heights: "حسب المشروع", apps: "مشاريع خاصة، نيوم، مواقع تراثية ومموهة", industries: "الحكومة، المدن الذكية، المشاريع الكبرى" },
  },
];

// ---------- Telecom Materials ----------
export const materialCategories = [
  {
    id: "antennas", icon: "Satellite", image: IMG.towerSunset,
    en: { title: "Antennas", items: ["Sector Antennas", "Microwave Antennas", "Omni Antennas"] },
    ar: { title: "الهوائيات", items: ["هوائيات قطاعية", "هوائيات ميكروويف", "هوائيات شاملة"] },
  },
  {
    id: "fiber", icon: "Network", image: IMG.engineer,
    en: { title: "Fiber Optic Solutions", items: ["Fiber Cables", "Patch Cords", "Pigtails", "ODF", "Closures", "Fiber Accessories"] },
    ar: { title: "حلول الألياف الضوئية", items: ["كابلات الألياف", "وصلات Patch", "Pigtails", "ODF", "علب الوصل", "ملحقات الألياف"] },
  },
  {
    id: "rf", icon: "Radio", image: IMG.heroTower,
    en: { title: "RF Solutions", items: ["Feeder Cables", "Jumpers", "Connectors", "RF Accessories"] },
    ar: { title: "حلول الترددات الراديوية", items: ["كابلات التغذية", "وصلات Jumper", "موصلات", "ملحقات RF"] },
  },
  {
    id: "power", icon: "BatteryCharging", image: IMG.siteWork,
    en: { title: "Power Systems", items: ["Batteries", "Rectifiers", "Solar Systems"] },
    ar: { title: "أنظمة الطاقة", items: ["البطاريات", "الموحدات", "الأنظمة الشمسية"] },
  },
  {
    id: "accessories", icon: "Wrench", image: IMG.cityNight,
    en: { title: "Tower Accessories", items: ["Aviation Lights", "Earthing Kits", "Lightning Protection", "Cable Trays", "Cable Ladders", "Clamps", "Brackets"] },
    ar: { title: "ملحقات الأبراج", items: ["أضواء الطيران", "أطقم التأريض", "الحماية من الصواعق", "أحواض الكابلات", "سلالم الكابلات", "المشابك", "الحوامل"] },
  },
];

// ---------- Projects ----------
// category keys: towers | infrastructure | buildings | materials | engineering
export const projectFilters = ["all", "towers", "infrastructure", "buildings", "materials", "engineering"];

export const projects = [
  { id: 1, image: IMG.heroTower, category: "towers", en: { title: "Macro Tower Rollout — Riyadh", meta: "120 Self-Support Towers" }, ar: { title: "نشر أبراج ماكرو — الرياض", meta: "١٢٠ برجاً ذاتي الدعم" } },
  { id: 2, image: IMG.towerSunset, category: "towers", en: { title: "Monopole Network — NEOM Corridor", meta: "Highway Coverage" }, ar: { title: "شبكة أحادية العمود — ممر نيوم", meta: "تغطية الطرق السريعة" } },
  { id: 3, image: IMG.cityNight, category: "infrastructure", en: { title: "Fiber Backbone — Jeddah Metro", meta: "FTTH & OSP Networks" }, ar: { title: "العمود الفقري للألياف — جدة", meta: "شبكات FTTH وOSP" } },
  { id: 4, image: IMG.siteWork, category: "infrastructure", en: { title: "Duct Banks & Manholes — Dammam", meta: "OSP Infrastructure" }, ar: { title: "قنوات وغرف تفتيش — الدمام", meta: "بنية تحتية خارجية" } },
  { id: 5, image: IMG.engineer, category: "buildings", en: { title: "Steel Structure — Jubail Industrial", meta: "Industrial Facility" }, ar: { title: "هيكل فولاذي — الجبيل الصناعية", meta: "منشأة صناعية" } },
  { id: 6, image: IMG.siteWork, category: "buildings", en: { title: "Commercial Complex — Riyadh", meta: "Office & Retail" }, ar: { title: "مجمع تجاري — الرياض", meta: "مكاتب وتجزئة" } },
  { id: 7, image: IMG.towerSunset, category: "materials", en: { title: "Antenna & RF Supply — STC", meta: "Materials Package" }, ar: { title: "توريد هوائيات وRF — STC", meta: "حزمة مواد" } },
  { id: 8, image: IMG.cityNight, category: "materials", en: { title: "Power & Earthing Kits — Multi-Site", meta: "Equipment Supply" }, ar: { title: "أنظمة طاقة وتأريض — مواقع متعددة", meta: "توريد معدات" } },
  { id: 9, image: IMG.engineer, category: "engineering", en: { title: "Site Survey & Design — Eastern Province", meta: "Engineering Package" }, ar: { title: "مسح وتصميم موقع — المنطقة الشرقية", meta: "حزمة هندسية" } },
  { id: 10, image: IMG.heroTower, category: "engineering", en: { title: "Structural Analysis & BOQ — Mega Project", meta: "Technical Consulting" }, ar: { title: "تحليل إنشائي وجدول كميات — مشروع ضخم", meta: "استشارات فنية" } },
];

// ---------- Industries ----------
export const industries = [
  { icon: "RadioTower", en: { title: "Telecom Operators", desc: "End-to-end tower and network rollout for national operators." }, ar: { title: "مشغلو الاتصالات", desc: "نشر متكامل للأبراج والشبكات للمشغلين الوطنيين." } },
  { icon: "HardHat", en: { title: "Infrastructure Contractors", desc: "Reliable subcontracting for towers, civil and fiber scope." }, ar: { title: "مقاولو البنية التحتية", desc: "مقاولات موثوقة للأبراج والأعمال المدنية والألياف." } },
  { icon: "Flame", en: { title: "Oil & Gas", desc: "Hazardous-area compliant communications structures." }, ar: { title: "النفط والغاز", desc: "هياكل اتصالات متوافقة مع المناطق الخطرة." } },
  { icon: "Zap", en: { title: "Utilities", desc: "Private network towers for power, water and grid control." }, ar: { title: "المرافق", desc: "أبراج شبكات خاصة للطاقة والمياه والتحكم." } },
  { icon: "Building2", en: { title: "Smart Cities", desc: "Densified small-cell and IoT-ready infrastructure." }, ar: { title: "المدن الذكية", desc: "بنية تحتية مكثفة بخلايا صغيرة وجاهزة لإنترنت الأشياء." } },
  { icon: "Landmark", en: { title: "Government Projects", desc: "Standards-compliant delivery for national initiatives." }, ar: { title: "المشاريع الحكومية", desc: "تنفيذ متوافق مع المعايير للمبادرات الوطنية." } },
  { icon: "Factory", en: { title: "Industrial Facilities", desc: "Plant-wide communications and safety networks." }, ar: { title: "المنشآت الصناعية", desc: "شبكات اتصالات وسلامة على مستوى المنشأة." } },
  { icon: "Server", en: { title: "Data Centers", desc: "Connectivity infrastructure and rooftop solutions." }, ar: { title: "مراكز البيانات", desc: "بنية اتصال وحلول أسطح." } },
  { icon: "TrainFront", en: { title: "Transportation Sector", desc: "Trackside, highway and airport communications." }, ar: { title: "قطاع النقل", desc: "اتصالات السكك والطرق والمطارات." } },
];

// ---------- About: What Makes Us Different ----------
export const pillars = [
  { icon: "Network", en: { title: "Network of Qualified Partners", desc: "Access a vetted network of suppliers, contractors, and engineering companies across Saudi Arabia and the GCC." }, ar: { title: "شبكة من الشركاء المؤهلين", desc: "وصول إلى شبكة مدققة من الموردين والمقاولين والشركات الهندسية في المملكة ودول الخليج." } },
  { icon: "Files", en: { title: "One RFQ, Multiple Quotations", desc: "Submit your requirements once and receive several competitive quotations to compare." }, ar: { title: "طلب واحد، عروض متعددة", desc: "أرسل متطلباتك مرة واحدة واستلم عدة عروض أسعار تنافسية للمقارنة." } },
  { icon: "Clock", en: { title: "Save Time & Effort", desc: "Skip contacting suppliers one by one — reach the entire market through a single submission." }, ar: { title: "توفير الوقت والجهد", desc: "تجاوز التواصل مع الموردين واحداً تلو الآخر — صِل إلى السوق بأكمله عبر طلب واحد." } },
  { icon: "Scale", en: { title: "Better Comparison & Decision Making", desc: "Evaluate technical and commercial proposals side by side to choose the best value." }, ar: { title: "مقارنة وقرارات أفضل", desc: "قيّم المقترحات الفنية والتجارية جنباً إلى جنب لاختيار أفضل قيمة." } },
  { icon: "Handshake", en: { title: "Business Opportunities for Suppliers & Contractors", desc: "Qualified partners gain access to a steady stream of real project opportunities." }, ar: { title: "فرص أعمال للموردين والمقاولين", desc: "يحصل الشركاء المؤهلون على تدفق مستمر من فرص المشاريع الحقيقية." } },
  { icon: "MapPinned", en: { title: "Saudi Arabia & GCC Coverage", desc: "Regional reach across the Kingdom and the wider Gulf region." }, ar: { title: "تغطية المملكة ودول الخليج", desc: "تغطية إقليمية في المملكة ومنطقة الخليج الأوسع." } },
];

// ---------- RFQ wizard options ----------
const toAr = (n) => String(n).replace(/[0-9]/g, (d) => "٠١٢٣٤٥٦٧٨٩"[+d]);
const genHeights = () => Array.from({ length: 145 }, (_, i) => { const m = i + 6; return { v: `${m}m`, en: `${m}m`, ar: `${toAr(m)}م` }; });
const genQty = () => Array.from({ length: 200 }, (_, i) => { const n = i + 1; return { v: String(n), en: String(n), ar: toAr(n) }; });

export const rfqOptions = {
  need: [
    { v: "Telecom Towers", en: "Telecom Towers", ar: "أبراج الاتصالات" },
    { v: "Telecom Infrastructure", en: "Telecom Infrastructure", ar: "البنية التحتية للاتصالات" },
    { v: "Buildings & Civil Projects", en: "Buildings & Civil Projects", ar: "المباني والمشاريع المدنية" },
    { v: "Telecom Materials & Equipment", en: "Telecom Materials & Equipment", ar: "مواد ومعدات الاتصالات" },
    { v: "Engineering Services", en: "Engineering Services", ar: "الخدمات الهندسية" },
    { v: "Other", en: "Other", ar: "أخرى" },
  ],
  towerType: [
    { v: "Monopole Tower", en: "Monopole Tower", ar: "برج أحادي العمود" },
    { v: "Self-Support Tower", en: "Self-Support Tower", ar: "برج ذاتي الدعم" },
    { v: "3-Leg Tower", en: "3-Leg Tower", ar: "برج ثلاثي القوائم" },
    { v: "4-Leg Tower", en: "4-Leg Tower", ar: "برج رباعي القوائم" },
    { v: "Guyed Tower", en: "Guyed Tower", ar: "برج مشدود" },
    { v: "Rooftop Tower", en: "Rooftop Tower", ar: "برج سطحي" },
    { v: "Temporary Tower", en: "Temporary Tower", ar: "برج مؤقت" },
    { v: "Custom Tower", en: "Custom Tower", ar: "برج مخصص" },
    { v: "Need Recommendation", en: "Need Recommendation", ar: "أحتاج توصية" },
  ],
  height: genHeights(),
  towerQuantity: genQty(),
  towerConfig: [
    { v: "Same Tower Type", en: "Same Tower Type", ar: "نفس نوع البرج" },
    { v: "Multiple Tower Types", en: "Multiple Tower Types", ar: "أنواع أبراج متعددة" },
  ],
  standards: [
    { v: "Aramco Standards", en: "Aramco Standards", ar: "معايير أرامكو" },
    { v: "NEOM Standards", en: "NEOM Standards", ar: "معايير نيوم" },
    { v: "Salam Standards", en: "Salam Standards", ar: "معايير سلام" },
    { v: "STC Standards", en: "STC Standards", ar: "معايير STC" },
    { v: "Mobily Standards", en: "Mobily Standards", ar: "معايير موبايلي" },
    { v: "Zain Standards", en: "Zain Standards", ar: "معايير زين" },
    { v: "SEC Standards", en: "SEC Standards", ar: "معايير الشركة السعودية للكهرباء" },
    { v: "Client Specifications", en: "Client Specifications", ar: "مواصفات العميل" },
    { v: "International Standards", en: "International Standards", ar: "المعايير الدولية" },
    { v: "Standard Commercial Solution", en: "Standard Commercial Solution", ar: "حل تجاري قياسي" },
    { v: "Need Recommendation", en: "Need Recommendation", ar: "أحتاج توصية" },
  ],
  scope: [
    { v: "Design Only", en: "Design Only", ar: "تصميم فقط" },
    { v: "Supply Only", en: "Supply Only", ar: "توريد فقط" },
    { v: "Installation Only", en: "Installation Only", ar: "تركيب فقط" },
    { v: "Design & Supply", en: "Design & Supply", ar: "تصميم وتوريد" },
    { v: "Supply & Installation", en: "Supply & Installation", ar: "توريد وتركيب" },
    { v: "Design, Supply & Installation", en: "Design, Supply & Installation", ar: "تصميم وتوريد وتركيب" },
    { v: "Turnkey Project", en: "Turnkey Project", ar: "مشروع متكامل" },
    { v: "Maintenance", en: "Maintenance", ar: "صيانة" },
  ],
  projectStatus: [
    { v: "Concept Stage", en: "Concept Stage", ar: "مرحلة الفكرة" },
    { v: "Design Stage", en: "Design Stage", ar: "مرحلة التصميم" },
    { v: "Tender Stage", en: "Tender Stage", ar: "مرحلة المناقصة" },
    { v: "Approved Project", en: "Approved Project", ar: "مشروع معتمد" },
    { v: "Ready for Execution", en: "Ready for Execution", ar: "جاهز للتنفيذ" },
    { v: "Immediate Requirement", en: "Immediate Requirement", ar: "احتياج فوري" },
  ],
  deliveryTime: [
    { v: "Within 3 Days", en: "Within 3 Days", ar: "خلال ٣ أيام" },
    { v: "Within 5 Days", en: "Within 5 Days", ar: "خلال ٥ أيام" },
    { v: "Within 1 Week", en: "Within 1 Week", ar: "خلال أسبوع" },
    { v: "Within 2 Weeks", en: "Within 2 Weeks", ar: "خلال أسبوعين" },
    { v: "Within 1 Month", en: "Within 1 Month", ar: "خلال شهر" },
    { v: "Within 2 Months", en: "Within 2 Months", ar: "خلال شهرين" },
    { v: "Flexible Schedule", en: "Flexible Schedule", ar: "جدول مرن" },
    { v: "As Per Project Requirements", en: "As Per Project Requirements", ar: "حسب متطلبات المشروع" },
  ],
  priority: [
    { v: "Urgent", en: "Urgent", ar: "عاجل" },
    { v: "High Priority", en: "High Priority", ar: "أولوية عالية" },
    { v: "Normal", en: "Normal", ar: "عادي" },
    { v: "Low Priority", en: "Low Priority", ar: "أولوية منخفضة" },
  ],
  documentTypes: [
    { v: "BOQ", en: "BOQ", ar: "جدول الكميات" },
    { v: "Drawings", en: "Drawings", ar: "المخططات" },
    { v: "Technical Specifications", en: "Technical Specifications", ar: "المواصفات الفنية" },
    { v: "Site Photos", en: "Site Photos", ar: "صور الموقع" },
    { v: "Tender Documents", en: "Tender Documents", ar: "وثائق المناقصة" },
    { v: "Structural Calculations", en: "Structural Calculations", ar: "الحسابات الإنشائية" },
    { v: "Google Earth Images", en: "Google Earth Images", ar: "صور جوجل إيرث" },
    { v: "Supporting Documents", en: "Supporting Documents", ar: "مستندات داعمة" },
  ],

  // --- Telecom Infrastructure ---
  infraType: [
    { v: "Fiber Optic Networks", en: "Fiber Optic Networks", ar: "شبكات الألياف الضوئية" },
    { v: "FTTH Projects", en: "FTTH Projects", ar: "مشاريع FTTH" },
    { v: "OSP Networks", en: "OSP Networks", ar: "شبكات OSP" },
    { v: "Telecom Shelters", en: "Telecom Shelters", ar: "غرف الاتصالات" },
    { v: "Duct Banks", en: "Duct Banks", ar: "قنوات الكابلات" },
    { v: "Manholes", en: "Manholes", ar: "غرف التفتيش" },
    { v: "Infrastructure Expansion", en: "Infrastructure Expansion", ar: "توسعة البنية التحتية" },
    { v: "Other", en: "Other", ar: "أخرى" },
  ],
  infraScale: [
    { v: "Single Site", en: "Single Site", ar: "موقع واحد" },
    { v: "Multiple Sites", en: "Multiple Sites", ar: "مواقع متعددة" },
    { v: "City-Wide", en: "City-Wide", ar: "على مستوى المدينة" },
    { v: "Regional", en: "Regional", ar: "إقليمي" },
  ],
  infraScopeOfWork: [
    { v: "Supply Only", en: "Supply Only", ar: "توريد فقط" },
    { v: "Installation Only", en: "Installation Only", ar: "تركيب فقط" },
    { v: "Supply & Installation", en: "Supply & Installation", ar: "توريد وتركيب" },
    { v: "Design & Build", en: "Design & Build", ar: "تصميم وتنفيذ" },
    { v: "Turnkey Solution", en: "Turnkey Solution", ar: "حل متكامل" },
    { v: "Maintenance", en: "Maintenance", ar: "صيانة" },
  ],

  // --- Buildings & Civil Projects ---
  buildingType: [
    { v: "Commercial Building", en: "Commercial Building", ar: "مبنى تجاري" },
    { v: "Shopping Mall", en: "Shopping Mall", ar: "مركز تسوق" },
    { v: "Office Building", en: "Office Building", ar: "مبنى مكاتب" },
    { v: "Residential Building", en: "Residential Building", ar: "مبنى سكني" },
    { v: "Warehouse", en: "Warehouse", ar: "مستودع" },
    { v: "Industrial Facility", en: "Industrial Facility", ar: "منشأة صناعية" },
    { v: "Steel Structure", en: "Steel Structure", ar: "هيكل فولاذي" },
    { v: "Other", en: "Other", ar: "أخرى" },
  ],
  buildingArea: [
    { v: "Up to 500 m²", en: "Up to 500 m²", ar: "حتى ٥٠٠ م²" },
    { v: "500 – 2,000 m²", en: "500 – 2,000 m²", ar: "٥٠٠ – ٢٠٠٠ م²" },
    { v: "2,000 – 10,000 m²", en: "2,000 – 10,000 m²", ar: "٢٠٠٠ – ١٠٠٠٠ م²" },
    { v: "Over 10,000 m²", en: "Over 10,000 m²", ar: "أكثر من ١٠٠٠٠ م²" },
    { v: "Not Sure", en: "Not Sure", ar: "غير محدد" },
  ],
  buildingFloors: [
    { v: "Single Floor", en: "Single Floor", ar: "طابق واحد" },
    { v: "2 – 5 Floors", en: "2 – 5 Floors", ar: "٢ – ٥ طوابق" },
    { v: "6 – 15 Floors", en: "6 – 15 Floors", ar: "٦ – ١٥ طابق" },
    { v: "15+ Floors", en: "15+ Floors", ar: "١٥+ طابق" },
    { v: "Not Applicable", en: "Not Applicable", ar: "لا ينطبق" },
  ],
  buildingScope: [
    { v: "Design", en: "Design", ar: "تصميم" },
    { v: "Construction", en: "Construction", ar: "إنشاء" },
    { v: "Design & Build", en: "Design & Build", ar: "تصميم وتنفيذ" },
    { v: "Turnkey Solution", en: "Turnkey Solution", ar: "حل متكامل" },
    { v: "Renovation", en: "Renovation", ar: "تجديد" },
    { v: "Structural Works", en: "Structural Works", ar: "أعمال إنشائية" },
    { v: "MEP Works", en: "MEP Works", ar: "أعمال كهروميكانيكية" },
  ],

  // --- Telecom Materials & Equipment ---
  materialCategory: [
    { v: "Antennas", en: "Antennas", ar: "الهوائيات" },
    { v: "Microwave Equipment", en: "Microwave Equipment", ar: "معدات الميكروويف" },
    { v: "Fiber Optic Materials", en: "Fiber Optic Materials", ar: "مواد الألياف الضوئية" },
    { v: "RF Materials", en: "RF Materials", ar: "مواد RF" },
    { v: "Power Systems", en: "Power Systems", ar: "أنظمة الطاقة" },
    { v: "Batteries", en: "Batteries", ar: "البطاريات" },
    { v: "Aviation Obstruction Lights", en: "Aviation Obstruction Lights", ar: "أضواء عوائق الطيران" },
    { v: "Earthing Systems", en: "Earthing Systems", ar: "أنظمة التأريض" },
    { v: "Tower Accessories", en: "Tower Accessories", ar: "ملحقات الأبراج" },
    { v: "Other", en: "Other", ar: "أخرى" },
  ],
  materialQuantity: [
    { v: "Small Quantity", en: "Small Quantity", ar: "كمية صغيرة" },
    { v: "Medium Quantity", en: "Medium Quantity", ar: "كمية متوسطة" },
    { v: "Large Quantity", en: "Large Quantity", ar: "كمية كبيرة" },
    { v: "Bulk / Project Volume", en: "Bulk / Project Volume", ar: "كمية مشروع كبيرة" },
    { v: "As Per BOQ", en: "As Per BOQ", ar: "حسب جدول الكميات" },
  ],
  materialPurpose: [
    { v: "New Project", en: "New Project", ar: "مشروع جديد" },
    { v: "Replacement", en: "Replacement", ar: "استبدال" },
    { v: "Maintenance Stock", en: "Maintenance Stock", ar: "مخزون صيانة" },
    { v: "Expansion", en: "Expansion", ar: "توسعة" },
    { v: "Resale", en: "Resale", ar: "إعادة بيع" },
  ],

  // --- Engineering Services ---
  engService: [
    { v: "Site Survey", en: "Site Survey", ar: "مسح الموقع" },
    { v: "Design & Drawings", en: "Design & Drawings", ar: "التصميم والمخططات" },
    { v: "Structural Analysis", en: "Structural Analysis", ar: "التحليل الإنشائي" },
    { v: "BOQ Preparation", en: "BOQ Preparation", ar: "إعداد جداول الكميات" },
    { v: "Technical Consulting", en: "Technical Consulting", ar: "الاستشارات الفنية" },
    { v: "Feasibility Study", en: "Feasibility Study", ar: "دراسة جدوى" },
    { v: "Other", en: "Other", ar: "أخرى" },
  ],
  engProjectType: [
    { v: "Telecom Towers", en: "Telecom Towers", ar: "أبراج الاتصالات" },
    { v: "Telecom Infrastructure", en: "Telecom Infrastructure", ar: "البنية التحتية للاتصالات" },
    { v: "Buildings & Civil", en: "Buildings & Civil", ar: "المباني والمدني" },
    { v: "Industrial", en: "Industrial", ar: "صناعي" },
    { v: "Other", en: "Other", ar: "أخرى" },
  ],
  engDeliverable: [
    { v: "Drawings", en: "Drawings", ar: "المخططات" },
    { v: "Reports", en: "Reports", ar: "التقارير" },
    { v: "BOQ", en: "BOQ", ar: "جداول الكميات" },
    { v: "Calculations", en: "Calculations", ar: "الحسابات" },
    { v: "Full Design Package", en: "Full Design Package", ar: "حزمة تصميم كاملة" },
  ],
};

// ---------- Trust counters ----------
// NOTE: Update `partners` value as the verified network grows.
export const counters = [
  { key: "projects", value: 480, suffix: "+" },
  { key: "rfqs", value: 1250, suffix: "+" },
  { key: "towers", value: 920, suffix: "+" },
  { key: "cities", value: 36, suffix: "" },
  { key: "partners", value: 127, suffix: "+" },
];

// ---------- Partner business categories ----------
export const partnerCategories = [
  { v: "Telecom Towers", en: "Telecom Towers", ar: "أبراج الاتصالات" },
  { v: "Telecom Infrastructure", en: "Telecom Infrastructure", ar: "البنية التحتية للاتصالات" },
  { v: "FTTH", en: "FTTH", ar: "FTTH" },
  { v: "Civil Works", en: "Civil Works", ar: "الأعمال المدنية" },
  { v: "Engineering Services", en: "Engineering Services", ar: "الخدمات الهندسية" },
  { v: "Telecom Materials & Equipment", en: "Telecom Materials & Equipment", ar: "مواد ومعدات الاتصالات" },
  { v: "Power Systems", en: "Power Systems", ar: "أنظمة الطاقة" },
  { v: "Other", en: "Other", ar: "أخرى" },
];

export const clientLogos = [
  "STC", "Mobily", "Zain", "Salam", "NEOM", "Aramco", "Red Sea", "Nesma",
];

// ---------- Why Choose Our Platform ----------
export const whyChooseFeatures = [
  { icon: "Receipt", en: { title: "Competitive Quotations", desc: "Receive multiple competitive quotations from trusted suppliers and contractors." }, ar: { title: "عروض أسعار تنافسية", desc: "استلم عروض أسعار تنافسية متعددة من موردين ومقاولين موثوقين." } },
  { icon: "ShieldCheck", en: { title: "Verified Industry Partners", desc: "Work with qualified telecom infrastructure companies and service providers." }, ar: { title: "شركاء معتمدون", desc: "تعامل مع شركات ومزودي خدمات بنية تحتية مؤهلين." } },
  { icon: "Clock", en: { title: "Time Saving", desc: "Submit your requirements once and receive multiple offers." }, ar: { title: "توفير الوقت", desc: "أرسل متطلباتك مرة واحدة واستلم عروضاً متعددة." } },
  { icon: "Wrench", en: { title: "Engineering & Technical Support", desc: "Access engineering expertise and technical consultation for your projects." }, ar: { title: "الدعم الهندسي والفني", desc: "احصل على خبرة هندسية واستشارة فنية لمشاريعك." } },
  { icon: "Network", en: { title: "Extensive Supplier Network", desc: "Connect with tower suppliers, contractors, telecom material providers, and infrastructure specialists." }, ar: { title: "شبكة موردين واسعة", desc: "تواصل مع موردي الأبراج والمقاولين ومزودي المواد ومتخصصي البنية التحتية." } },
  { icon: "Zap", en: { title: "Fast Response", desc: "Receive prompt feedback and quotation support." }, ar: { title: "استجابة سريعة", desc: "احصل على ردود سريعة ودعم في عروض الأسعار." } },
  { icon: "Award", en: { title: "Telecom & Infrastructure Experts", desc: "Benefit from industry knowledge and project experience." }, ar: { title: "خبراء الاتصالات والبنية التحتية", desc: "استفد من المعرفة الصناعية وخبرة المشاريع." } },
  { icon: "BadgeCheck", en: { title: "Warranty Options Available", desc: "Selected projects may qualify for warranty programs and after-sales support through approved partners." }, ar: { title: "خيارات ضمان متاحة", desc: "قد تتأهل مشاريع مختارة لبرامج ضمان ودعم ما بعد البيع عبر شركاء معتمدين." } },
  { icon: "Users", en: { title: "One Request, Multiple Suppliers", desc: "Reach multiple qualified suppliers and contractors through one submission." }, ar: { title: "طلب واحد، موردون متعددون", desc: "تواصل مع موردين ومقاولين مؤهلين متعددين عبر طلب واحد." } },
];

// ---------- Our Solutions ----------
export const solutionCategories = [
  {
    id: "towers", icon: "RadioTower", image: IMG.heroTower,
    en: { title: "Telecom Towers", items: ["Monopole Towers", "Self-Support Towers", "3-Leg Towers", "4-Leg Towers", "Guyed Towers", "Rooftop Towers", "Temporary Towers", "Tower Relocation", "Tower Maintenance"] },
    ar: { title: "أبراج الاتصالات", items: ["الأبراج أحادية العمود", "الأبراج ذاتية الدعم", "أبراج ثلاثية القوائم", "أبراج رباعية القوائم", "الأبراج المشدودة", "أبراج الأسطح", "الأبراج المؤقتة", "نقل الأبراج", "صيانة الأبراج"] },
  },
  {
    id: "infrastructure", icon: "Network", image: IMG.cityNight,
    en: { title: "Telecom Infrastructure", items: ["Fiber Optic Networks", "FTTH Projects", "OSP Networks", "Telecom Shelters", "Duct Banks", "Manholes", "Infrastructure Expansion"] },
    ar: { title: "البنية التحتية للاتصالات", items: ["شبكات الألياف الضوئية", "مشاريع FTTH", "شبكات OSP", "غرف الاتصالات", "قنوات الكابلات", "غرف التفتيش", "توسعة البنية التحتية"] },
  },
  {
    id: "buildings", icon: "Building2", image: IMG.siteWork,
    en: { title: "Buildings & Civil Projects", items: ["Commercial Buildings", "Shopping Malls", "Office Buildings", "Residential Buildings", "Warehouses", "Industrial Facilities", "Steel Structures"] },
    ar: { title: "المباني والمشاريع المدنية", items: ["المباني التجارية", "المراكز التجارية", "مباني المكاتب", "المباني السكنية", "المستودعات", "المنشآت الصناعية", "الهياكل الفولاذية"] },
  },
  {
    id: "materials", icon: "Boxes", image: IMG.towerSunset,
    en: { title: "Telecom Materials & Equipment", items: ["Antennas", "Microwave Equipment", "Fiber Optic Materials", "RF Materials", "Power Systems", "Batteries", "Aviation Obstruction Lights", "Earthing Systems", "Tower Accessories"] },
    ar: { title: "مواد ومعدات الاتصالات", items: ["الهوائيات", "معدات الميكروويف", "مواد الألياف الضوئية", "مواد RF", "أنظمة الطاقة", "البطاريات", "أضواء عوائق الطيران", "أنظمة التأريض", "ملحقات الأبراج"] },
  },
  {
    id: "engineering", icon: "Compass", image: IMG.engineer,
    en: { title: "Engineering Services", items: ["Site Survey", "Design & Drawings", "Structural Analysis", "BOQ Preparation", "Technical Consulting"] },
    ar: { title: "الخدمات الهندسية", items: ["مسح الموقع", "التصميم والمخططات", "التحليل الإنشائي", "إعداد جداول الكميات", "الاستشارات الفنية"] },
  },
];

// ---------- Clients & Partners ----------
export const partnerGroups = [
  { id: "clients", en: "Clients", ar: "العملاء", logos: ["STC", "Mobily", "Zain", "Salam"] },
  { id: "suppliers", en: "Suppliers", ar: "الموردون", logos: ["Huawei", "Nokia", "Ericsson", "CommScope"] },
  { id: "contractors", en: "Contractors", ar: "المقاولون", logos: ["Nesma", "Al Bawani", "Almabani", "Shibh Al Jazira"] },
  { id: "partners", en: "Strategic Partners", ar: "الشركاء الاستراتيجيون", logos: ["NEOM", "Aramco", "Red Sea Global", "SEC"] },
];

// Called by SiteContext after CMS settings load. It updates image references that were
// materialized inside the legacy data arrays when this module first loaded.
export const applyRuntimeAssets = (assets = {}) => {
  const resolved = Object.fromEntries(Object.entries(assets || {}).filter(([, v]) => v));
  const urlToKey = Object.fromEntries(Object.entries(DEFAULT_IMG).map(([k, v]) => [v, k]));
  const groups = [towerTypes, materialCategories, projects, industries, solutionCategories];
  groups.forEach((list) => {
    (list || []).forEach((item) => {
      if (!item || !item.image) return;
      const key = item.__imageKey || urlToKey[item.image];
      if (!key) return;
      Object.defineProperty(item, "__imageKey", { value: key, writable: true, enumerable: false, configurable: true });
      item.image = resolved[key] || DEFAULT_IMG[key];
    });
  });
};
